import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from '../../pages/secure/admin/manage-users/shared/user.service';

@Injectable()
export class ValidGuidAuthGuard  {

  private guid: string;
  private isValid: boolean;

  constructor(private router: Router, private userService: UserService) { }

  async canActivate(route: ActivatedRouteSnapshot) {
      this.guid = route.paramMap.get('guid');

     await this.userService.validateResetPasswordGuid(this.guid).toPromise().then(res => {
        this.isValid = res;
      },
      error => {
        this.isValid = false;
      })
      .then(() => {
        if (!this.isValid) {
            this.router.navigate(['/login']);
            return false;
        } else {
          return true;
        }
      })
      .catch(() => this.isValid = false);

      return this.isValid;
  }
}
